export default __webpack_public_path__ + "static/discover-ampm-cb6655d609e500e7289bf65a44a45d69.svg";